import { render, staticRenderFns } from "./galeria-componente.vue?vue&type=template&id=5f90f285&scoped=true"
import script from "./galeria-componente.vue?vue&type=script&lang=js"
export * from "./galeria-componente.vue?vue&type=script&lang=js"
import style0 from "./galeria-componente.vue?vue&type=style&index=0&id=5f90f285&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90f285",
  null
  
)

export default component.exports